import React from "react";
import "./ViewMoreGallery.css";

function ViewMoreGallery(props) {
  const { className } = props;

  return (
    <div className={`view-more-gallery-2 ${className || ""}`}>
      <div className="group-142">
        <div className="overlap-group-15">
          <div className="rectangle-62"></div>
          <div className="view-more-1 poppins-medium-white-10px">View More</div>
        </div>
      </div>
    </div>
  );
}

export default ViewMoreGallery;
